<div class="po-wrapper">
    <!-- <po-menu *ngIf="isLogged" [p-menus]="menus" p-filter></po-menu> -->
    <po-menu *ngIf="isLogged" [p-menus]="menus" p-filter p-logo="../assets/img/logo-fsb-negativa.png" p-short-logo="../assets/img/logo-fsb-negativa.png"></po-menu>

    <po-toolbar *ngIf="isLogged" [p-title]="tituloEmpresa" [p-profile]="profile" [p-profile-actions]="profileActions"></po-toolbar>

    <router-outlet></router-outlet>

</div>

<!-- <po-modal #poModal p-title="Insira o CNPJ do cliente que você deseja acessar " [p-primary-action]="confirm" [p-secondary-action]="close">
    <form [formGroup]="fornecedorForm" class="po-row" (keyup.enter)="buscarFornecedor()">
        <po-input class="po-sm-12 po-md-6 po-lg-12" p-mask="99.999.999/9999-99" p-clean formControlName="cnpj"></po-input>
    </form>
</po-modal> -->

<!-- Modal Sobre -->

<po-modal #modalSobre p-title="Sobre" [p-primary-action]="voltar">
    <po-info p-label="Versão Portal" p-label-size="20" p-orientation="horizontal" [p-value]="version"> </po-info>
    <po-info p-label="Versão PO-UI" p-label-size="20" p-orientation="horizontal" p-value="2.9.0"> </po-info>
</po-modal>